import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("set")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `${_ctx.routerName.usermanage}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("usermanage")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isEdit === "1" ? _ctx.t("edituser") : _ctx.t("newusers")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      name: "basic",
      autocomplete: "off",
      "label-col": _ctx.labelCol,
      style: {"width":"50%","margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          label: _ctx.t('username'),
          name: "username",
          rules: [{ required: true, message: _ctx.t('inputusername') + '!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event)),
              disabled: _ctx.isEdit === '1'
            }, null, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["label", "rules"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('tel')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_number, {
              value: _ctx.formState.mobile,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.mobile) = $event)),
              style: {"width":"100%"},
              controls: false
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('role')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.role_name,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.role_name) = $event)),
              disabled: true
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('loginpassword'),
          name: "password",
          rules: [{ required: true, message: _ctx.t('inputpassword') + '!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label", "rules"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('confirmpassword'),
          name: "confirm_password",
          rules: [{ required: true, message: _ctx.t('inputpassword') + '!' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.confirm_password,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.confirm_password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label", "rules"]),
        _createVNode(_component_a_form_item, {
          label: _ctx.t('car')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.formState.vins,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.vins) = $event)),
              mode: "multiple",
              allowClear: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.car_list, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.vin,
                    value: item.vin,
                    "onUpdate:value": ($event: any) => ((item.vin) = $event),
                    onClick: ($event: any) => (_ctx.clickItem(item.vin))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.vin), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "label-col"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_button, {
        onClick: _ctx.goBack,
        style: {"margin":"10% 20px 0 40%"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("cancellation")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        "html-type": "submit",
        onClick: _ctx.submitForm,
        style: {"background-color":"#4f6bff"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("submit")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}